import React, { useState } from "react";
import axios from "axios";
import { showSuccess } from "services/toast.service";
import { handleError } from "utils";
import { useHistory } from "react-router-dom";
import Button from "components/Button";
import { API_BASE_URL } from "config/constants";
import Logo from "../../assets/img/Logo.png";

export default function Register() {
  const history = useHistory();

  const [submitClick, setSubmitClick] = useState(false);
  const [loading, setLoading] = useState(false);
  const [register, setregister] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmpassword: "",
    role: "",
    skype: "",
    website: "",
    companyName: "",
    assignedTo: "",
  });

  const onChange = (e) => {
    setregister({ ...register, [e.target.name]: e.target.value });
  };

  const isValid = () => {
    console.log('regiseter is ', register);
    if (
      !register.name ||
      !register.email ||
      !register.phone ||
      !register.password ||
      !register.role ||
      !register.website ||
      !register.companyName
    )
      return false;
    return true;
  };

  const handleClick = () => {
    console.log('submit click ');
    setSubmitClick(true);
    if (!isValid()) return;

    userRegister(
      register.name,
      register.email,
      register.phone,
      register.password,
      register.role,
      register.skype,
      register.website,
      register.companyName
    );
  };

  const userRegister = async (
    name,
    email,
    phone,
    password,
    role,
    skype,
    website,
    companyName
  ) => {
    try {
      setLoading(true);
      const response = await axios.post(`${API_BASE_URL}/user/register`, {
        name,
        email,
        phone,
        password,
        role,
        skype,
        website,
        companyName,
      });
      console.log(response);
      setLoading(false);
      showSuccess(response?.data?.result?.message);
      history.push("/auth/login");
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  return (
    <>
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-6/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center mb-3">
                  <div onClick={()  => history.push('/')} className="w-1/2 md:p-4  cursor-pointer text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold px-0">
                    <img src={Logo} alt="Logo" />
                  </div>
                  <h6 className="text-blueGray-500 text-sm font-bold">
                    Sign up with
                  </h6>
                </div>

                <hr className="mt-6 border-b-1 border-blueGray-300" />
              </div>
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form>
                  <div className="flex flex-wrap">
                    <div className="w-full lg:w-6/12 px-4">
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          value={register.name}
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          defaultValue=""
                          name="name"
                          onChange={onChange}
                        />
                        {submitClick && !register.name && (
                          <div className="text-red-500 text-sm mt-1 font-semibold">
                            Name is required!
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-full lg:w-6/12 px-4">
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          value={register.email}
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          defaultValue=""
                          name="email"
                          onChange={onChange}
                        />
                        {submitClick && !register.email && (
                          <div className="text-red-500 text-sm mt-1 font-semibold">
                            Email is required!
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="w-full lg:w-6/12 px-4">
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Phone
                        </label>
                        <input
                          type="text"
                          value={register.phone}
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          defaultValue=""
                          name="phone"
                          onChange={onChange}
                        />
                        {submitClick && !register.phone && (
                          <div className="text-red-500 text-sm mt-1 font-semibold">
                            Phone is required!
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="w-full lg:w-6/12 px-4">
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Password
                        </label>
                        <input
                          type="password"
                          autoComplete="new-password"
                          value={register.password}
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          defaultValue=""
                          name="password"
                          onChange={onChange}
                        />
                        {submitClick && !register.password && (
                          <div className="text-red-500 text-sm mt-1 font-semibold">
                            Password is required!
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="w-full lg:w-6/12 px-4">
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Role
                        </label>
                        <select
                          value={register.role}
                          onChange={onChange}
                          name="role"
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        >
                          <option value="">Choose Role</option>
                          <option value="Publisher">Publisher</option>
                          <option value="Advertizer">Advertizer</option>
                        </select>

                        {submitClick && !register.role && (
                          <div className="text-red-500 text-sm mt-1 font-semibold">
                            Role is required!
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-full lg:w-6/12 px-4">
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Skype
                        </label>
                        <input
                          type="text"
                          value={register.skype}
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          name="skype"
                          onChange={onChange}
                        />
                      </div>
                    </div>

                    <div className="w-full lg:w-6/12 px-4">
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Website
                        </label>
                        <input
                          type="text"
                          value={register.website}
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          name="website"
                          onChange={onChange}
                        />
                        {submitClick && !register.website && (
                          <div className="text-red-500 text-sm mt-1 font-semibold">
                            Website is required!
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="w-full lg:w-6/12 px-4">
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Company
                        </label>
                        <input
                          type="text"
                          value={register.companyName}
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          name="companyName"
                          onChange={onChange}
                        />
                        {submitClick && !register.companyName && (
                          <div className="text-red-500 text-sm mt-1 font-semibold">
                            Company is required!
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* <div>
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        id="customCheckLogin"
                        type="checkbox"
                        className="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150"
                      />
                      <span className="ml-2 text-sm font-semibold text-blueGray-600">
                        I agree with the{" "}
                        <a
                          href="#pablo"
                          className="text-lightBlue-500"
                          onClick={(e) => e.preventDefault()}
                        >
                          Privacy Policy
                        </a>
                      </span>
                    </label>
                  </div> */}

                  <div className="px-4 flex items-center w-full justify-center mt-4">
                    <Button
                      title={"SIGNUP"}
                      handleClick={handleClick}
                      loading={loading}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
